import { removeAllWidgetFilters } from 'containers/AnalyticsDashboard/utils';
import { TRACKING_CONSTANTS } from 'containers/Tracking/utils';
import moment from 'moment-timezone';
import { CognitoTokens } from 'types/auth';

/**
 * @returns {Object} if user is authenticated - an object with {idToken, accessToken} read from the local storage
 * @returns {undefined} if user is not authenticated
 * @description the function will act like a sync
 */
export function getTokenFromLocalStorage() {
  if (isUserAuthenticated()) {
    const idToken = localStorage.getItem('idToken');
    const accessToken = localStorage.getItem('accessToken');
    if (idToken && accessToken) {
      return { idToken, accessToken };
    }
  }
  return undefined;
}

export function getUserInfo() {
  return localStorage.getItem('userInfo');
}

export function saveToken(token: string) {
  if (token) {
    localStorage.setItem('token', token);
  }
}

export function saveCognitoTokens(tokens: CognitoTokens) {
  if (tokens) {
    localStorage.setItem('idToken', tokens.idToken);
    localStorage.setItem('accessToken', tokens.accessToken);
    localStorage.setItem('isUserAuthenticated', 'true');
  }
}

export function isUserAuthenticated() {
  return localStorage.getItem('isUserAuthenticated') ? true : false;
}

export function saveUserInfo(userInfo: unknown) {
  localStorage.setItem('userInfo', JSON.stringify(userInfo));
}

//----------------------------Tracking--------------------------
export const getShowCustomersOnMap = () => {
  return (
    localStorage.getItem('showCustomersOnMap') || TRACKING_CONSTANTS.SHOW_MAP_MARKERS.CUSTOMER.SHOW
  );
};

export const updateShowCustomersOnMap = (showCustomers: string) => {
  localStorage.setItem('showCustomersOnMap', showCustomers);
};

export const updateBreadCrumbsView = (showBreadCrumbs: string) => {
  localStorage.setItem('showBreadCrumbs', showBreadCrumbs);
};

//----Filters

interface GetTrackingFilterProps {
  defaultValueForFilters: {
    date: string;
    crewId: string;
    equipmentId: string;
  };
}
export const getTrackingFilter = ({ defaultValueForFilters }: GetTrackingFilterProps) => {
  const storedTrackingFilters = localStorage.getItem('trackingFilters');

  const defaultFilter = {
    date: {
      date: new Date(),
      start: '12:AM',
      end: '11:PM'
    },
    crews: [],
    customers: [],
    showCustomerPin: TRACKING_CONSTANTS.SHOW_MAP_MARKERS.CUSTOMER.SHOW,
    equipments: [],
    showEquipmentBreadCrumb: 'Off',
    equipmentStatus: [],
    jobStatus: []
  };

  if (Object.keys(defaultValueForFilters).length > 0) {
    const filters = {
      ...defaultFilter,
      date: {
        ...defaultFilter.date,
        date: defaultValueForFilters?.date
          ? moment(defaultValueForFilters.date).toDate()
          : defaultFilter.date.date
      },
      crews: defaultValueForFilters?.crewId ? [defaultValueForFilters.crewId] : defaultFilter.crews,
      equipments: defaultValueForFilters?.equipmentId
        ? [Number(defaultValueForFilters.equipmentId)]
        : defaultFilter.equipments
    };
    updateTrackingFilters(filters);
    return filters;
  }

  if (storedTrackingFilters) {
    const parsedData = JSON.parse(storedTrackingFilters);
    return { ...parsedData, date: { ...parsedData.date, date: new Date(parsedData.date.date) } };
  }

  return defaultFilter;
};

export const updateTrackingFilters = (data: unknown) => {
  const dataToUpdate = JSON.stringify(data);
  localStorage.setItem('trackingFilters', dataToUpdate);
};

//--------------------------------------------------------------

export function removeItem() {
  localStorage.removeItem('isUserAuthenticated');
  localStorage.removeItem('accessToken');
  localStorage.removeItem('idToken');
  localStorage.removeItem('userInfo');
  localStorage.removeItem('employeeInfo');
  localStorage.removeItem('notification-token');
  localStorage.removeItem('holidays');
  localStorage.removeItem('popup');
  localStorage.removeItem('showCustomersOnMap');
  sessionStorage.removeItem('cache');
  localStorage.removeItem('isNavigatingFromTracking');
  localStorage.removeItem('trackingFilters');
  removeAllWidgetFilters();
}

export function getPopUp() {
  return localStorage.getItem('popup');
}

export function setPopUp() {
  localStorage.setItem('popup', JSON.stringify(true));
}

export function setCacheSettings(cache: unknown) {
  //don't cache for admin.
  const userInfo = JSON.parse(getUserInfo()!);
  if (!userInfo.isAdmin) {
    sessionStorage.setItem('cache', JSON.stringify(cache));
  }
}

export function getCacheSettings() {
  return sessionStorage.getItem('cache');
}
export function saveEmployeeInfo(employeeInfo: unknown) {
  localStorage.setItem('employeeInfo', JSON.stringify(employeeInfo));
}
export function getEmployeeInfo() {
  return localStorage.getItem('employeeInfo');
}

export function setSignUpFlowFromApp(signUpFlowStates: unknown) {
  return sessionStorage.setItem('signUpFlowFromApp', JSON.stringify(signUpFlowStates));
}

export function getSignUpFlowFromApp() {
  return JSON.parse(sessionStorage.getItem('signUpFlowFromApp')!);
}
